<template>
  <div class="sort-class">
    <a-row
      v-for="(item, index) in data.optionsList"
      :key="index"
      :class="{ 'selected-class': isSelected(item), 'disabled-class': disabled }"
      @click="handleChange(item)"
    >
      <div>
        {{ selectedIndex(item) || '' }}
      </div>
      {{ item.optionContent }}
    </a-row>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue'

const props = defineProps({
  data: {
    required: true,
    type: Object,
    default: {}
  },
  value: {
    required: true,
    type: Array,
    default: []
  },
  disabled: {
    required: true,
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:value', 'change'])
const checkValue = ref([])

const isSelected = (item: any) => checkValue.value.includes(item.id ? item.id : item.optionContent)

const selectedIndex = (item: any) => {
  const index = checkValue.value.indexOf(item.id ? item.id : item.optionContent)
  return index !== -1 ? index + 1 : ''
}
// 暂定入参
const handleChange = (val: any) => {
  if (props.disabled) return
  if (isSelected(val)) {
    checkValue.value = checkValue.value.filter(
      item => item !== (val.id ? val.id : val.optionContent)
    )
  } else {
    checkValue.value.push(val.id ? val.id : val.optionContent)
  }
  let arr = checkValue.value.map((item: any) => {
    return {
      optionId: item,
      otherContent: '',
      othersFlag: undefined
    }
  })
  emit('change', arr)
}

onMounted(async () => {
  if (props.data.fieldValue) {
    checkValue.value = props.data.fieldValue.map((item: any) => item.optionId)
  }
})
</script>
<style lang="less" scoped>
.sort-class {
  width: 100%;
  .ant-row {
    align-items: center;
    background-color: rgb(247, 248, 249);
    margin-bottom: 8px;
    border-radius: 2px;
    border: 1px solid transparent;
    line-height: 30px;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      border-color: #ff4d4f;
      cursor: pointer;
      background-color: #fff;
    }
    div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid rgb(216, 216, 216);
      margin: 0 8px 0 12px;
      font-size: 12px;
      color: #fff;
    }
  }
  .selected-class {
    background-color: #fff;
    border-color: rgb(215, 0, 15);
    div {
      border-color: rgb(215, 0, 15);
      background-color: rgb(215, 0, 15);
    }
  }
  .disabled-class {
    background-color: rgb(247, 248, 249) !important;
    border-color: transparent !important;
    &:hover {
      cursor: not-allowed;
    }
    div {
      border-color: #c8c9cc !important;
      background-color: #ebedf0 !important;
      color: #c8c9cc;
    }
  }
}
</style>
